import { cn } from '../utils/cn';

type MetricCardProps = {
    label: string;
    value: string | number;
    tone?: 'default' | 'danger' | 'warn' | 'ok';
    icon?: React.ReactNode;
};

const tones: Record<NonNullable<MetricCardProps['tone']>, string> = {
    default: 'border-gray-200 bg-white dark:border-gray-700 dark:bg-gray-800',
    danger:  'border-red-200 bg-red-50 dark:border-red-900 dark:bg-red-950/40',
    warn:    'border-amber-200 bg-amber-50 dark:border-amber-900 dark:bg-amber-950/40',
    ok:      'border-emerald-200 bg-emerald-50 dark:border-emerald-900 dark:bg-emerald-950/40',
};

export function MetricCard({ label, value, tone = 'default', icon }: MetricCardProps) {
    return (
        <div className={cn('rounded-lg border p-4 shadow-sm', tones[tone])}>
            <div className="flex items-start justify-between gap-3">
                <div>
                    <p className="text-xs font-medium uppercase tracking-wide text-gray-500 dark:text-gray-400">{label}</p>
                    <p className="mt-2 text-3xl font-bold text-gray-900 dark:text-gray-100">{value}</p>
                </div>
                {icon ? <figure className="opacity-90 [&>svg]:h-10 [&>svg]:w-10">{icon}</figure> : null}
            </div>
        </div>
    );
}

export function MetricGrid({ children, className }: { children: React.ReactNode; className?: string }) {
    return <div className={cn('grid gap-4 sm:grid-cols-2 xl:grid-cols-4', className)}>{children}</div>;
}
